import { Directive, HostListener, Output, EventEmitter} from '@angular/core';

@Directive({
  selector: '[appMapListeners]'
})
export class MapListenersDirective {

  constructor() { }

  @Output() resizeWindow: EventEmitter<any> = new EventEmitter();

  @Output() mousewheel: EventEmitter<any> = new EventEmitter();

  @Output() mouseupInMap: EventEmitter<any> = new EventEmitter();

  @HostListener('mousewheel', ['$event'])
  onMousewheel(event: MouseEvent): any {
    if (event.x < 0) {
      this.mousewheel.emit(event);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): any {
    if (event.type !== 'resize') {
      this.resizeWindow.emit(event);
    }
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent): any {
    if (event.x < 0) {
     this.mouseupInMap.emit(event);
    }
  }

}
